import { AllUnitOptionValues } from './unit.options';

export const UnitAbbreviations: Record<AllUnitOptionValues, string> = {
  // APM
  span: 'spans',

  // 비트 Bits
  'bit (b) - Bits': 'b',
  'byte (B) - Bits': 'B',
  'kilobit (kb)': 'kb',
  'megabit (mb)': 'mb',
  'gigabit (gb)': 'gb',
  'terabit (tb)': 'tb',
  'petabit (pb)': 'pb',
  'exabit (eb)': 'eb',

  // 바이트(바이너리) Bytes(binary)
  'bit (b) - Bytes(binary)': 'b',
  'byte (B) - Bytes(binary)': 'B',
  'kibibyte (KiB)': 'KiB',
  'mebibyte (MiB)': 'MiB',
  'gibibyte (GiB)': 'GiB',
  'tebibyte (TiB)': 'TiB',
  'pebibyte (PiB)': 'PiB',
  'exbibyte (EiB)': 'EiB',

  // 바이트 Bytes(decimal)
  'bit (b) - Bytes(decimal)': 'b',
  'byte (B) - Bytes(decimal)': 'B',
  'kilobyte (KB)': 'KB',
  'megabyte (MB)': 'MB',
  'gigabyte (GB)': 'GB',
  'terabyte (TB)': 'TB',
  'petabyte (PB)': 'PB',
  'exabyte (EB)': 'EB',

  // 초당 비트 Bits/sec
  'bit (b)/sec - Bits/sec': 'b/s',
  'byte (B)/sec - Bits/sec': 'B/s',
  'kilobit (kb)/sec': 'kb/s',
  'megabit (mb)/sec': 'mb/s',
  'gigabit (gb)/sec': 'gb/s',
  'terabit (tb)/sec': 'tb/s',
  'petabit (pb)/sec': 'pb/s',
  'exabit (eb)/sec': 'eb/s',

  // 초당 바이트(바이너리) Bytes(binary)
  'bit (b)/sec - Bytes(binary)/sec': 'b/s',
  'byte (B)/sec - Bytes(binary)/sec': 'B/s',
  'kibibyte (KiB)/sec': 'KiB/s',
  'mebibyte (MiB)/sec': 'MiB/s',
  'gibibyte (GiB)/sec': 'GiB/s',
  'tebibyte (TiB)/sec': 'TiB/s',
  'pebibyte (PiB)/sec': 'PiB/s',
  'exbibyte (EiB)/sec': 'EiB/s',

  // 캐시 Cache
  hit: 'hits',
  miss: 'misses',
  eviction: 'evictions',
  get: 'gets',
  set: 'sets',

  // CPU
  'nanocore (ncores)': 'ncores',
  'microcore (μcores)': 'μcores',
  'millicore (mcores)': 'mcores',
  core: 'cores',
  'kilocore (Kcores)': 'Kcores',
  'megacore (Mcores)': 'Mcores',
  'gigacore (Gcores)': 'Gcores',
  'teracore (Tcores)': 'Tcores',
  'petacore (Pcores)': 'Pcores',
  'exacore (Ecores)': 'Ecores',

  // 전류 Current
  'milliampere (mA)': 'mAs',
  'ampere (A)': 'As',

  // DB
  table: 'tables',
  'index (idx)': 'idxs',
  lock: 'locks',
  'transaction (tx)': 'txs',
  query: 'queries',
  row: 'rows',
  key: 'keys',
  'command (cmd)': 'cmds',
  offset: 'offsets',
  record: 'records',
  object: 'objects',
  cursor: 'cursors',
  'assertion (assert)': 'asserts',
  scan: 'scans',
  document: 'documents',
  shard: 'shards',
  flush: 'flushes',
  merge: 'merges',
  refresh: 'refreshes',
  fetch: 'fetches',
  'column (col)': 'cols',
  commit: 'commits',
  wait: 'waits',
  ticket: 'tickets',
  question: 'questions',
  collection: 'collections',
  entity: 'entities',
  vector: 'vectors',

  // 디스크 Disk
  file: 'files',
  inode: 'inodes',
  sector: 'sectors',
  'block (blk)': 'blks',
  volume: 'volumes',

  // 주파수 Frequency
  'hertz (Hz)': 'Hz',
  'kilohertz (kHz)': 'kHz',
  'megahertz (MHz)': 'MHz',
  'gigahertz (GHz)': 'GHz',

  // 일반
  'buffer (buff)': 'buffs',
  'error (err)': 'errs',
  'read (rd)': 'rds',
  'write (wr)': 'wrs',
  occurrence: 'occurrences',
  event: 'events',
  time: 'times',
  unit: 'units',
  'operation (op)': 'ops',
  item: 'items',
  task: 'tasks',
  worker: 'workers',
  'resource (res)': 'res',
  'garbage collection (gc)': 'gcs',
  email: 'emails',
  'sample (smpl)': 'smpls',
  stage: 'stages',
  monitor: 'monitors',
  location: 'locations',
  check: 'checks',
  attempt: 'attempts',
  'device (dev)': 'devs',
  'update (up)': 'ups',
  'method (mthd)': 'mthds',
  job: 'jobs',
  container: 'containers',
  execution: 'executions',
  throttle: 'throttles',
  invocation: 'invocations',
  user: 'users',
  success: 'successes',
  build: 'builds',
  prediction: 'predictions',
  exception: 'exceptions',
  alert: 'alerts',
  // for api
  topic: 'topics',
  'consumer group': 'consumer groups',
  count: 'counts',
  state: 'states',
  'minute (min) or terabyte (TiB)': 'min or TiB',
  stat: 'stats',
  credit: 'credits',
  number: 'numbers',
  'count/sec': 'count/sec',
  'count/second': 'count/second',
  num: 'nums',
  'topic partition': 'topic partitions',
  lsn: 'lsns',
  bool: 'bools',
  none: 'none',
  credits: 'credits',
  'count / minute (min)': 'count / min',
  age: 'ages',
  'count / 5 minute (min)': 'count / 5 mins',
  'vCPU-minutes': 'vCPU-mins',
  'sec/count': 'sec/count',
  string: 'strings',

  // 기록 Logging
  entry: 'entries',

  // 메모리 Memory
  'page (pg)': 'pgs',
  split: 'splits',
  Heap: 'heaps',

  // 화폐 Money
  'won (₩)': '₩',
  'nanodollar (n$)': 'n$',
  'microdollar (μ$)': 'μ$',
  'cent (¢)': '¢',
  'dollar ($)': '$',
  'yen (¥)': '¥',
  'yuan (¥)': '¥',

  // 네트워크 Network
  'connection (conn)': 'conns',
  'request (req)': 'reqs',
  'packet (pkt)': 'pkts',
  'segment (seg)': 'segs',
  'response (rsp)': 'rsps',
  'message (msg)': 'msgs',
  payload: 'payloads',
  timeout: 'timeouts',
  datagram: 'datagrams',
  route: 'routes',
  session: 'sessions',
  hop: 'hops',

  // 백분율 Percentage
  'percent nano (n%)': 'n%',
  'percent (%)': '%',
  apdex: 'apdex',
  fraction: 'fraction',

  // 퍼텐셜 (Potential)
  'millivolt (mV)': 'mVs',
  'volt (V)': 'Vs',

  // 전력 (Power)
  'nanowatt (nW)': 'nW',
  'microwatt (μW)': 'μW',
  'milliwatt (mW)': 'mW',
  'deciwatt (dW)': 'dW',
  'watt (W)': 'W',
  'kilowatt (kW)': 'kW',
  'megawatt (MW)': 'MW',
  'gigawatt (GW)': 'GW',
  'terawatt (TW)': 'TW',

  // 신서틱 (Synthetic)
  run: 'runs',
  step: 'steps',

  // 시스템 System
  'process (proc)': 'procs',
  thread: 'threads',
  host: 'hosts',
  node: 'nodes',
  fault: 'Faults',
  'service (svc)': 'svcs',
  instance: 'instances',
  cpu: 'cpus',

  // 온도 Temperature
  'decidegree celsius (d°C)': 'd°C',
  'degree celsius (°C)': '°C',
  'degree fahrenheit (°F)': '°F',

  // 시간 Time
  'nanosecond (ns)': 'ns',
  'microsecond (μs)': 'μs',
  'millisecond (ms)': 'ms',
  'centisecond (cs)': 'cs',
  'second (s)': 's',
  'minute (min)': 'min',
  'hour (hr)': 'hr',
  day: 'days',
  'week (wk)': 'wk',
  month: 'months',
  year: 'years',
};
